const host = "https://www.sagishutrit.nl/images/helena";

export const recentworks = [
    {
        src: `${host}/closets_2026may_oil_on_canvas_30_40.jpg`,
        title: 'zonder titel',
        year: '2026',
        medium: 'Oliverf op doek',
        dimensions: '30 bij 40 cm',
        width: '500px',
        aspectRatio:'3334/2613'
    },
    {
        src: `${host}/Former_satelite_Striped_Rock2026_100b70.jpg`,
        title: 'zonder titel',
        year: '2026',
        medium: 'Oliverf op doek',
        dimensions: '100 bij 70 cm',
        // width: '500px',
        // aspectRatio:'3334/2613'
    },

    {
        src: `${host}/Carousele_2026_70b100cm.png`,
        title: 'Carousele',
        year: '2026',
        medium: 'Oliverf op doek',
        dimensions: '30 bij 40 cm',
        width: '700px'
    }, {
        src: `${host}/untitled_canvas_framed2026.jpg`,
        title: 'zonder titel',
        year: '2026',
        medium: 'Oliverf op doek',
        dimensions: '70 bij 100 cm',
        width: '500px'
    },
    {
        src: `${host}/She_doesnt_Know_her_Name2026_80b80.png`,
        title: 'Stoere Meid in Scherven',
        year: '2026',
        medium: 'Oliverf op doek',
        dimensions: '80 bij 80 cm',
        width: '500px'
    },
    {
        src: `${host}/untitled_linnen2026.jpg`,
        title: 'zonder titel',
        year: '2026',
        medium: 'Oliverf op doek',
        dimensions: '32 bij 32 cm',
        width: '500px'
     },
    {
        src: `${host}/ritualOilOnCanvas2025_100b70.jpg`,
        title: 'zonder titel',
        year: '2025',
        medium: 'Oliverf op doek',
        dimensions: '100 x 70 cm',
        width: '500px'
    },
    {
        src: `${host}/family_status_westend.png`,
        title: 'Op de bonnefooi',
        year: '2025-2026',
        medium: 'Oliverf op doek',
        dimensions: '180 x 120 cm',
        width: '900px'
    },

    {
        src: `${host}/carousel-plentage.png`,
        title: 'Plentage',
        year: '2025',
        medium: 'Oliverf op doek',
        dimensions: '40 x 50 cm',
        width: '600px',
        aspectRatio:'800/534'
    },

    {
        // temporary path as all img here should be on helena
        src: "https://sagishutrit.viewingrooms.nl/assets/shuarma_in_the_mall.jpg",
        title: 'Yes, of course there is a shawarma place in the new mall',
        year: '2025',
        medium: 'Oliverf op doek',
        dimensions: '160 x 130 cm',
        width: '800px'
    }, 
    {
        src: `${host}/she_fights_in_silence2025_100b70.jpg`,
        title:"Onderhuids",
        year: '2025',
        medium: 'Oliverf op doek',
        dimensions: '100 bij 70 cm',
        width: '500px'
    },
    {
        
        src: `${host}/Girls_Night_Out_2025_80b60cmOilOnCanvas.png`,
        title: 'Girls night out',
        year: '2025',
        medium: 'Oliverf op doek',
        width:'500px',
        dimensions: '80 x 60 cm',      
    }, 
    {
        src: `${host}/groentuin_2025.jpg`,
        title: 'Tuindorp',
        year: '2025',
        medium: 'Aquarel en gouache op papier',
        dimensions: '40 x 50 cm',
        width: '600px',

    },

    {
        src: `${host}/vasoline_2025_40_50.png`,
        title: 'Vasoline',
        year: '2025',
        medium: 'Oliverf op doek',
        dimensions: '40 x 50 cm',
        width: '600px',
        aspectRatio:'1000/838'
    },

 
];  


// Stil geweld — compact en dubbelzinnig: innerlijke strijd, sociale druk,
//     maar ook de paradox van iets dat tegelijk stil en gewelddadig is.
// Onderhuids - under the skin , neit wat ze doet maar waar de srijd zich bevindt 